var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8125 3.5625V11M28.8125 3.5625C28.8125 2.5 27.75 1.4375 26.6875 1.4375H3.3125C2.25 1.4375 1.1875 2.5 1.1875 3.5625M28.8125 3.5625L16.2091 12.2877C15.8538 12.5336 15.432 12.6653 15 12.6653C14.568 12.6653 14.1462 12.5336 13.7909 12.2877L1.1875 3.5625M1.1875 3.5625V18.4375C1.1875 19.5 2.25 20.5625 3.3125 20.5625H15M18.7188 18.4375L21.9062 21.625L28.2812 15.25",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailChecked);
export default __webpack_public_path__ + "static/media/email_checked.7cd2ea248f27259ae98fb11ce3ff4a11.svg";
export { ForwardRef as ReactComponent };